import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=5b32a5b2&scoped=true&"
import script from "./Placeholder.vue?vue&type=script&lang=js&"
export * from "./Placeholder.vue?vue&type=script&lang=js&"
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=5b32a5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b32a5b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
